/* eslint-disable ember/classic-decorator-no-classic-methods, ember/no-get, ember/no-runloop, warp-drive/no-legacy-request-patterns */
import { tracked } from '@glimmer/tracking';
import Controller from '@ember/controller';
import { action } from '@ember/object';
import { cancel, debounce } from '@ember/runloop';
import { service } from '@ember/service';
import { isEmpty } from '@ember/utils';
import AuthSyncStatus from 'linced-admin/enums/auth-sync-status';
import AuthSyncType from 'linced-admin/enums/auth-sync-type';

export default class FusionauthController extends Controller {
  // Attrs
  AuthSyncType = AuthSyncType;

  // Services
  @service
  session;

  @service
  store;

  @service
  toaster;

  // State
  @tracked
  syncing = false;

  @tracked
  syncComplete = false;
  @tracked syncErrors = null;
  @tracked syncStatus = false;
  @tracked
  syncType = '';
  @tracked
  pollTimer = false;
  @tracked count = 0;
  @tracked created = 0;
  @tracked updated = 0;
  @tracked failed = 0;

  get createdPercent() {
    return (this.created / this.count) * 100;
  }

  get updatedPercent() {
    return (this.updated / this.count) * 100;
  }

  get failedPercent() {
    return (this.failed / this.count) * 100;
  }

  // reset provides a method to reset the controller to an expected state when
  // wanting to perform another sync.
  reset() {
    this.count = 0;
    this.created = 0;
    this.updated = 0;
    this.failed = 0;
    this.syncing = false;
    this.syncComplete = false;
    this.syncErrors = null;
    this.syncType = '';
  }

  // Methods
  updateStatus() {
    if (isEmpty(this.syncStatus)) {
      return;
    }
    this.syncStatus.reload().then((status) => {
      this.count = status.count;
      this.created = status.created;
      this.updated = status.updated;
      this.failed = status.failed;
      this.syncErrors = status.syncErrors;
      switch (status.status) {
        case AuthSyncStatus.PROCESSING:
          // Still processing - queue another update.
          this.pollTimer = debounce(this, 'updateStatus', 30000, false);
          break;

        case AuthSyncStatus.READY:
          // Finished processing - perform clean up.
          cancel(this.pollTimer);
          this.syncComplete = true;
          break;

        case AuthSyncStatus.FAILED:
          // OhNoes... 💩 hit the fan...
          cancel(this.pollTimer);
          this.syncComplete = true;

          // ensure we defend against the base case - nothing processed
          if (!this.created && !this.updated && !this.failed) {
            this.failed = status.count;
          }
          break;
      }
    });
  }

  @action
  syncFusionAuth(type) {
    this.reset();
    this.syncing = true;
    this.syncType = type;

    if (!isEmpty(this.pollTimer)) {
      // Cancel any pending status poll.
      cancel(this.pollTimer);
    }

    let newStatusRecord = {
      requesterId: this.get('session.person'),
      type,
    };

    this.store
      .createRecord('auth/status', newStatusRecord)
      .save()
      .then((syncStatus) => {
        this.toaster.success('FusionAuth Sync Started!');

        let pollTimer = debounce(this, 'updateStatus', 10000, false);
        this.syncStatus = syncStatus;
        this.pollTimer = pollTimer;
      })
      .catch(() => {
        this.toaster.error('FusionAuth Sync Failed!');
        this.syncing = false;
        cancel(this.pollTimer);
      });
  }

  @action
  closeSyncingDialog() {
    this.syncing = false;
  }
}
